<template>
  <div>
    <CreateNewUserDialog
      :dialog="showCreateNewUserDialog"
      @close="closeCreateNewUserDialog"
    >
    </CreateNewUserDialog>

    <EditUserDialog
      :dialog="showEditUserDialog"
      :user="user"
      :email="user.email"
      :role="user.role"
      @close="closeEditUserDialog"
    >
    </EditUserDialog>

    <ConfirmDialog
      :dialog="showConfirmDelete"
      @modalResult="confirmDeleteUserDialogResult"
      title="Delete User"
      :text=getDeleteText()
      yesColor="#f5f5f5"
    >

    </ConfirmDialog>
    <v-card>
      <v-toolbar
        color="light-green"
      >
        <v-toolbar-title>
          Users
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <div style="width: 300px;">
          <v-text-field
            placeholder="filter username"
            single-line
            v-model="filterUsername"
            append-icon="filter_list"
            class="mt-4 mr-3"
            @input="filter"
          >
          </v-text-field>
        </div>
      </v-toolbar>

      <v-data-table
        class="mt-5"
        single-select
        :footer-props="{ disableItemsPerPage: true, }"
        :headers="headers"
        :loading="busy"
        :items="users"
        :items-per-page="10"
        :server-items-length="serverItemsLength"
        :options.sync="options"
      >
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" @click.stop="openEditUserDialog(item)" v-on="on">edit</v-icon>
            </template>
            <span>Edit User</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" @click.stop="openConfirmDeleteDialog(item)" v-on="on">delete_forever</v-icon>
            </template>
            <span>Delete User</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="grey lighten-1"
          @click.stop="openCreateNewUserDialog()"
        >
          Create New User
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CreateNewUserDialog from '../components/users/CreateNewUserDialog.vue';
import ConfirmDialog from '../components/ConfirmDialog.vue';
import EditUserDialog from '../components/users/EditUserDialog.vue';

export default {
  components: {
    CreateNewUserDialog,
    ConfirmDialog,
    EditUserDialog,
  },

  data() {
    return {
      headers: [
        {
          text: 'Username',
          align: 'left',
          sortable: false,
          value: 'username',
          width: 100,
        },
        {
          text: 'E-mail',
          align: 'left',
          sortable: false,
          value: 'email',
          width: 200,
        },
        {
          text: 'Role',
          align: 'left',
          sortable: false,
          value: 'role',
          width: 100,
        },
        {
          text: 'Active',
          align: 'left',
          sortable: false,
          value: '_active',
          width: 100,
        },
        {
          text: 'Actions',
          align: 'left',
          sortable: false,
          value: 'action',
          width: 150,
        },
      ],
      options: {},
      busy: false,
      serverItemsLength: 0,
      users: [],

      filterUsername: '',

      showCreateNewUserDialog: false,

      user: {},

      showConfirmDelete: false,

      showEditUserDialog: false,
    };
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      const options = {
        method: 'get',
        url: `/read/users/v1/?page=${this.options.page || 1}&filterUsername=${this.filterUsername}`,
      };

      this.busy = true;

      this.axios(options)
        .then((res) => {
          this.busy = false;
          this.serverItemsLength = res.data.totalDocs;
          this.users = res.data.docs.map(cur => ({
            ...cur,
            _active: cur.active ? 'Yes' : 'No',
          }));
        })
        .catch((err) => {
          this.busy = false;
        });
    },

    filter() {
      this.getData();
    },

    openCreateNewUserDialog() {
      this.showCreateNewUserDialog = true;
    },

    closeCreateNewUserDialog(data) {
      if (data) {
        this.busy = true;

        const options = {
          method: 'post',
          url: '/create/user/v1/',
          data,
        };

        this.axios(options)
          .then((res) => {
            this.showCreateNewUserDialog = false;
            this.busy = false;
            this.getData();
          })
          .catch((err) => {
            this.showCreateNewUserDialog = false;
            this.busy = false;
          });
      } else {
        this.busy = false;
        this.showCreateNewUserDialog = false;
      }
    },

    openEditUserDialog(user) {
      this.user = user;
      this.showEditUserDialog = true;
    },

    closeEditUserDialog(data) {
      if (data) {
        this.busy = true;

        const options = {
          method: 'post',
          url: '/update/user/v1/',
          data,
        };

        this.axios(options)
          .then((res) => {
            this.showEditUserDialog = false;
            this.busy = false;
            this.getData();
          })
          .catch((err) => {
            this.showEditUserDialog = false;
            this.busy = false;
          });
      } else {
        this.busy = false;
        this.showEditUserDialog = false;
      }
    },

    getDeleteText() {
      return (`Are you sure you want to delete the user ${this.user.username}?`);
    },

    openConfirmDeleteDialog(user) {
      this.user = user;
      this.showConfirmDelete = true;
    },

    confirmDeleteUserDialogResult(confirmed) {
      if (confirmed) {
        const options = {
          method: 'post',
          url: '/delete/user/v1',
          data: {
            username: this.user.username,
          },
        };

        this.axios(options)
          .then((res) => {
            this.showConfirmDelete = false;
            this.user = {};

            this.getData();
          });
      } else {
        this.showConfirmDelete = false;
        this.user = {};
      }
    },
  },
};
</script>

<style scoped>
</style>
